import { Component, OnInit, signal } from '@angular/core';
import { BrowserDetectService } from '$core/services/browser-detect.service';
import {
  faExclamationCircle,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-browser-deprecation-warning',
  templateUrl: './browser-deprecation-warning.component.html',
  styleUrls: ['./browser-deprecation-warning.component.scss'],
})
export class BrowserDeprecationWarningComponent implements OnInit {
  protected readonly isVisible = signal(false);
  isDismissed = false;
  browserName = '';
  requiredVersion = '';
  readonly faExclamationCircle = faExclamationCircle;
  readonly faTimes = faTimes;

  private readonly STORAGE_KEY = 'browser-deprecation-warning-dismissed';

  constructor(private readonly browserDetectService: BrowserDetectService) {}

  public ngOnInit(): void {
    this.isDismissed = this.getStoredDismissalState();

    if (!this.isDismissed && this.browserDetectService.isDeprecatingSoon()) {
      this.isVisible.set(true);
      this.browserName = this.browserDetectService.getBrowserDisplayName();
      this.requiredVersion =
        this.browserDetectService.getRequiredVersion() || '';
    }
  }

  public dismiss(): void {
    this.isVisible.set(false);
    this.isDismissed = true;
    this.saveDismissalState();
  }

  private saveDismissalState(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    } catch (e) {}
  }

  private getStoredDismissalState(): boolean {
    try {
      return localStorage.getItem(this.STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }
}
